/* ==========================================================================
   PIELLE 2.0 · assets/pielle-contacto.js
   Estado de atención en vivo de la página de contacto: marca data-open="1|0"
   según la hora de Argentina. El CSS de pielle-contacto.css pinta el punto y
   el texto a partir de ese atributo. No escribe ni cambia ningún texto.
   ========================================================================== */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('[data-plct]').forEach(function (box) {
      if (box.dataset.plctReady) return;
      box.dataset.plctReady = '1';
      var days = (box.dataset.openDays || '1,2,3,4,5').split(',').map(function (n) { return parseInt(n, 10); });
      var from = parseInt(box.dataset.openFrom, 10);
      var to = parseInt(box.dataset.openTo, 10);
      function tick() {
        var now;
        try {
          now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));
        } catch (e) { now = new Date(); }
        var open = days.indexOf(now.getDay()) > -1 && now.getHours() >= from && now.getHours() < to;
        box.setAttribute('data-open', open ? '1' : '0');
      }
      tick();
      setInterval(tick, 60000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
